<template>
  <div class="contenedor-detalle-pago" v-if="showThisComponent">
    <div>
      <div class="detalle-pago-title" v-on:click="showSection = !showSection">
        <h1>Detalle de pago</h1>
        <span v-bind:class="[
          showSection ? 'rotate-270' : 'rotate-90',
          'icon-chevron-r',
          'detalle-pago-title-icon',
        ]"></span>
      </div>
      <div class="detalle-pago-lista-facturas" v-if="showSection">
        <div class="detalle-pago-lista-facturas-top no-seleccionable">
          <p>Factura No.</p>
          <p>Vencimiento</p>
          <p>Valor a pagar</p>
        </div>
        <div class="detalle-pago-lista-facturas-data no-seleccionable">
          <div class="detalle-pago-lista-facturas-data-item" v-for="(factura, index) in facturas" :key="index">
            <div class="detalle-pago-lista-facturas-data-item-wrapper" v-if="shoudBeShowed(index + 1)">
              <div class="detalle-pago-lista-facturas-data-item-cell">
                <p>Factura No.</p>
                <p>{{ factura.numeroDeFactura }}</p>
              </div>
              <div class="detalle-pago-lista-facturas-data-item-cell">
                <p>Valor a pagar</p>
                <p>
                  {{ factura.fechaDeVencimiento | moment("DD-MM-YYYY") }}
                </p>
              </div>
              <div class="detalle-pago-lista-facturas-data-item-cell">
                <p>Vencimiento</p>
                <p>{{ factura.valorAPagar | numeralFormat("$0,0") }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="detalle-pago-lista-facturas-paginator" v-if="showSection && facturas.length > 10">
        <span v-on:click="changeCurrentPage(-1)"
          class="icon-chevron-r rotate-180 detalle-pago-lista-facturas-paginator-icon"></span>
        <a v-for="(page, index) in pages" :key="index" v-bind:class="[currentPage === page ? 'active-page' : '']"
          v-on:click="currentPage = page">{{ page }}</a>
        <span v-on:click="changeCurrentPage(1)" class="icon-chevron-r detalle-pago-lista-facturas-paginator-icon"></span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      showThisComponent: true,
      showSection: false,
      currentPage: 1,
      pages: [],
      facturas: null,
      valorTotal: 0,
      detalle_uuid: "",
      headers: {
        "Content-Type": "application/json",
        Authorization: "",
      },
    };
  },
  props: ["detallePagoUrl"],
  created() {
    this.detalle_uuid = localStorage.getItem("detalle_uuid");
    try {
      this.getPayDetail()
        .then((data) => {
          this.facturas = data.detallePago || [];
          let maxPages = Math.ceil(this.facturas.length / 10);
          for (let index = 1; index <= maxPages; index++) {
            this.pages.push(index);
          }
          this.facturas.forEach((factura) => {
            this.valorTotal += factura.valorAPagar;
          });
          this.$emit("update:valorTotal", this.valorTotal);
        })
        .catch((err) => {
          this.showThisComponent = false;
        });
    } finally {
      console.log("Finally")
    }
  },
  mounted() { },
  methods: {
    shoudBeShowed(position) {
      return 10 * (this.currentPage - 1) <= position &&
        position < 10 * this.currentPage
        ? true
        : false;
    },
    changeCurrentPage(value) {
      if (this.currentPage === 1) {
        if (value === -1) {
          return;
        }
      } else if (this.currentPage === this.pages.length) {
        if (value === 1) {
          return;
        }
      }
      this.currentPage = this.currentPage + value;
    },
    /**
     * Método que consult el listado de facturas asociadas a un UUID
     */
    async getPayDetail() {
      this.headers.Authorization = localStorage.getItem("oauth");
      const URL_DetallePago = localStorage.getItem("URL_DetallePago");

      let parametros = "";

      await axios
        .get(URL_DetallePago, {
          params: { uuid: this.detalle_uuid },
          headers: { Authorization: this.headers.Authorization }
        })
        .then((response) => {
          parametros = response.data;
        })
        .catch((error) => {
          this.showThisComponent = false;
        });
      return parametros;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/sass/variables.scss";

.contenedor-detalle-pago {
  display: flex;
  flex-flow: column;
}

.detalle-pago {
  &-title {
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #e1e4e6;

    h1 {
      color: $colorFallida;
      font-family: $bold;
      height: 32px;
      font-size: 24px;
      line-height: 32px;
      margin: 16px 1px;
    }

    &-icon {
      color: $colorFallida;
      font-size: 32px;
      margin-right: 10px;
    }
  }

  &-lista-facturas {
    display: flex;
    flex-flow: column;
    border: 1px solid #adaaaa;
    border-radius: 8px;
    margin-top: 36px;
    padding: 11px;

    &-top {
      font-family: $bold;
      display: flex;
      flex-flow: row;

      p {
        width: 33%;
        text-align: center;
        font-family: $bold;
        font-size: 21px;
      }
    }

    &-data {
      &-item:nth-child(2n + 1) {
        background-color: $gris4;
      }

      &-item {
        display: flex;
        flex-flow: row;
        justify-content: space-between;

        &-wrapper {
          width: 100%;
          display: flex;
        }

        &-cell p:first-child {
          display: none;
        }

        &-cell {
          width: 33%;
        }

        p {
          width: 100%;
          text-align: center;
          font-family: $medium;
          font-size: 18px;
        }
      }
    }

    &-paginator {
      display: flex;
      flex-flow: row;
      justify-content: center;
      align-items: center;
      width: 60%;
      margin: 32px auto;

      &-icon {
        color: black;
        font-size: 18px;
      }

      a {
        font-family: $medium;
        color: $gris1;
        font-size: 21px;
        width: 49px;
        height: 49px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 10px;
        cursor: pointer;
        -moz-user-select: none;
        -khtml-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }
    }
  }
}

span {
  cursor: pointer;
}

.active-page {
  background-color: $colorFallida;
  border-radius: 100%;
  color: $blanco !important;
  font-family: $bold !important;
}

.rotate-90 {
  transform: rotate(90deg);
}

.rotate-180 {
  transform: rotate(180deg);
}

.rotate-270 {
  transform: rotate(270deg);
}

@media (min-width: 601px) and (max-width: 910px) {
  .detalle-pago {
    &-title {
      h1 {
        font-size: 20px;
        padding-left: 10px;
      }

      span {
        font-size: 20px;
        margin-right: 24px;
      }
    }
  }
}

@media (max-width: 600px) {
  .detalle-pago {
    &-title {
      h1 {
        font-size: 20px;
        padding-left: 10px;
      }

      span {
        font-size: 20px;
        margin-right: 24px;
      }
    }

    &-lista-facturas {
      box-sizing: border-box;
      margin: 36px 19px 0;

      &-top {
        display: none;
      }

      &-data-item {
        &-cell p:first-child {
          display: block;
          font-family: $bold;
          margin: 19px auto 4px;
        }

        &-cell {
          display: flex;
          flex-flow: column;

          p {
            font-size: 12px;
            margin: 4px auto 19px;
          }
        }
      }

      &-paginator {
        width: 80%;
        margin: 16px auto;

        a {
          font-size: 18px;
          min-width: 39px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/DetallePago.vue